module.exports = __webpack_public_path__ + "img/paige.58e46179.jpg";